import React, { FC, FormEvent, useEffect, useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Search, X } from 'react-bootstrap-icons';
import { useAppTheme } from 'theme/useAppTheme';

interface IWiseTableSearchProps {
  value?: string;
  placeholder?: string;
  onChange?: (phrase: string) => void;
}

const WiseTableSearch: FC<IWiseTableSearchProps> = ({ onChange, placeholder, value = '' }) => {
  const theme = useAppTheme();
  const [searchQuery, setSearchQuery] = useState(value);

  useEffect(() => {
    setSearchQuery(value);
  }, [value]);

  const handleOnSubmit = (event: FormEvent) => {
    event.preventDefault();
    onChange?.(searchQuery);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onChange?.(searchQuery);
    }
  };

  const handleClear = () => {
    setSearchQuery('');
    onChange?.('');
  };

  return (
    <form onSubmit={handleOnSubmit} style={{ width: '100%' }}>
      <TextField
        fullWidth
        size="small"
        value={searchQuery}
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton type="submit" aria-label="Search" edge="start" size="small">
                <Search />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: searchQuery ? (
            <InputAdornment position="end">
              <IconButton
                onClick={handleClear}
                aria-label="Clear"
                edge="end"
                size="small"
                sx={{
                  padding: '4px'
                }}>
                <X size={20} />
              </IconButton>
            </InputAdornment>
          ) : null
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.background.paper,
            '& fieldset': {
              borderColor: theme.palette.app.textMutedAlpha
            },
            '&:hover fieldset': {
              borderColor: theme.palette.app.textMutedAlpha
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.app.secondaryLight
            }
          }
        }}
      />
    </form>
  );
};

export default WiseTableSearch;
